import { mutator } from 'satcheljs';
import getProfileStore from '../store/profileStore';
import { default as addAccount } from '../actions/addAccount';

export default mutator(addAccount, actionMessage => {
    const found = getProfileStore().accountSources.some(
        accountSource => accountSource.id === actionMessage.accountSource.id
    );

    if (found === false) {
        getProfileStore().accountSources.push(actionMessage.accountSource);
    } else {
        throw new Error('Found duplicated account in the store.');
    }
});
